import { type Store } from "vuex";
import { config } from "vuex-module-decorators";

import { followerStorePlugin } from "@/store/follower";
import { ltksStorePlugin } from "@/store/ltks";

declare module "vuex-module-decorators" {
  interface VuexModule {
    store: Store<unknown>;
  }
}

/**
 * Pinia store modules
 */
export * from "./carts";
export * from "./categories";
export * from "./checkout";
export * from "./consumer-search";
export * from "./creator-shop-search";
export * from "./retailer-product-links";
export * from "./settings";
export * from "./creator-shop-posts";
export * from "./signed-policies";

/**
 * Follow accessor pattern as outlined in the nuxt typescript cookbook.
 * https://typescript.nuxtjs.org/cookbook/store/#class-based
 */
const initializer = (_: Store<unknown>) => {
  config.rawError = true;
};

export const state = () => ({});
export const plugins = [initializer, followerStorePlugin, ltksStorePlugin];
